import { OnlineOrdersConfigs } from "../store/kitchen/kitchen.types";

export type OrderTypeValue = "takeaway" | "dinein" | "delivery";

export const ORDER_TYPE_QUERY_PARAM = "orderType";
export const TABLE_NUMBER_QUERY_PARAM = "tableNumber";

/**
 * Derive UI order type from URL params + online ordering config.
 * Delivery uses explicit `orderType=delivery`; dine-in keeps tableNumber backward compat.
 * Single-mode venues prefer the only enabled takeaway/dine-in flag over URL defaults.
 */
export const resolveOrderType = (
  searchParams: URLSearchParams | { get: (key: string) => string | null },
  onlineOrdersConfig: OnlineOrdersConfigs | null | undefined
): OrderTypeValue => {
  const orderTypeParam = searchParams.get(ORDER_TYPE_QUERY_PARAM);
  const tableNumber = searchParams.get(TABLE_NUMBER_QUERY_PARAM);

  if (orderTypeParam === "delivery" && onlineOrdersConfig?.deliveryEnabled) {
    return "delivery";
  }

  // Prefer capability flags for single-mode venues (from main #38).
  if (
    onlineOrdersConfig?.dineInEnabled &&
    !onlineOrdersConfig?.takeAwayEnabled
  ) {
    return "dinein";
  }
  if (
    onlineOrdersConfig?.takeAwayEnabled &&
    !onlineOrdersConfig?.dineInEnabled
  ) {
    return "takeaway";
  }
  if (
    onlineOrdersConfig?.deliveryEnabled &&
    !onlineOrdersConfig?.takeAwayEnabled &&
    !onlineOrdersConfig?.dineInEnabled
  ) {
    return "delivery";
  }

  if (
    (tableNumber === "" || tableNumber) &&
    onlineOrdersConfig?.dineInEnabled &&
    orderTypeParam !== "delivery"
  ) {
    return "dinein";
  }

  return "takeaway";
};

export const orderTypeToDisplayLabel = (orderType: OrderTypeValue): string => {
  switch (orderType) {
    case "dinein":
      return "Dine In";
    case "delivery":
      return "Delivery";
    case "takeaway":
    default:
      return "Take Away";
  }
};

export const getEnabledOrderTypes = (
  onlineOrdersConfig: OnlineOrdersConfigs | null | undefined
): OrderTypeValue[] => {
  const types: OrderTypeValue[] = [];
  if (onlineOrdersConfig?.takeAwayEnabled) types.push("takeaway");
  if (onlineOrdersConfig?.dineInEnabled) types.push("dinein");
  if (onlineOrdersConfig?.deliveryEnabled) types.push("delivery");
  return types;
};
